/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react'
import ReactCompareImage from 'react-compare-image'
import Popup from '../../components/popup'
import Button from '../../components/button'
import { FormattedMessage } from 'react-intl'

export default function Screenshots() {
  const [showPopup, togglePopup] = React.useState()
  const [activeImage, setActiveImg] = React.useState()
  const initialCompareState = { from: '', to: '' }
  const [compareImages, setCompareImages] = React.useState(initialCompareState)
  const initialSelectState = 'Choose a environment'
  const [selectValue1, setSelectValue1] = React.useState(initialSelectState)
  const [selectValue2, setSelectValue2] = React.useState(initialSelectState)

  // Import all screenshots dynamically
  function importAll(r) {
    return r.keys().map(r)
  }

  const localImages = importAll(require.context('./images/local', false, /\.png$/))
  const liveImages = importAll(require.context('./images/live', false, /\.png$/))
  const devImages = importAll(require.context('./images/dev', false, /\.png$/))
  const stagingImages = importAll(require.context('./images/staging', false, /\.png$/))

  // Figure which images to render
  const pageAmount = 14

  const envsToImages = {
    ...(localImages.length === pageAmount && {
      local: localImages,
    }),
    ...(liveImages.length === pageAmount && {
      live: liveImages,
    }),
    ...(devImages.length === pageAmount && {
      dev: devImages,
    }),
    ...(stagingImages.length === pageAmount && {
      staging: stagingImages,
    }),
  }

  // Browsing functions
  const increment = () => {
    if (activeImage < localImages.length - 1) {
      setActiveImg(activeImage + 1)

      if (envsToImages[selectValue1] && envsToImages[selectValue2]) {
        setCompareImages({
          from: envsToImages[selectValue1][activeImage + 1],
          to: envsToImages[selectValue2][activeImage + 1],
        })
      }
    }
  }

  const decrement = () => {
    if (activeImage > 0) {
      setActiveImg(activeImage - 1)
      if (envsToImages[selectValue1] && envsToImages[selectValue2]) {
        setCompareImages({
          from: envsToImages[selectValue1][activeImage - 1],
          to: envsToImages[selectValue2][activeImage - 1],
        })
      }
    }
  }

  const renderImages = () => {
    let imagesToRender = []

    if (localImages && localImages.length) {
      imagesToRender = localImages
    } else if (devImages && devImages.length) {
      imagesToRender = devImages
    } else if (stagingImages && stagingImages.length) {
      imagesToRender = stagingImages
    } else if (liveImages && liveImages.length) {
      imagesToRender = liveImages
    }

    return imagesToRender
  }

  return (
    <div
      style={{
        maxWidth: '1440px',
        margin: '0 auto',
        padding: '20px',
      }}
    >
      {showPopup && (
        <Popup
          contentStyle={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}
          onClose={() => {
            togglePopup(false)
          }}
          style={{ flexDirection: 'column', justifyContent: 'flex-start' }}
        >
          <div
            style={{
              margin: '2rem 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: 'white',
              borderRadius: '3px',
              padding: '1rem',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                disabled={activeImage < 1}
                onClick={() => decrement()}
                style={{ marginRight: '1rem' }}
                variant="success"
              >
                <FormattedMessage defaultMessage="Tillbaks" id="tools.screenshots.actions.buttons.previous" />
              </Button>
              <Button disabled={activeImage === localImages.length - 1} onClick={() => increment()} variant="success">
                <FormattedMessage defaultMessage="Nästa" id="tools.screenshots.actions.buttons.next" />
              </Button>
              <span style={{ marginLeft: '1rem' }}>{`${activeImage + 1}/${localImages.length}`}</span>
            </div>
            {liveImages[activeImage] && (
              <div>
                <span style={{ marginRight: '1rem' }}>
                  <FormattedMessage defaultMessage="Jämför" id="tools.screenshots.actions.toggle" />
                </span>

                <select
                  onBlur={() => {}}
                  onChange={(e) => {
                    setCompareImages({
                      from: Object.keys(envsToImages).includes(e.target.value)
                        ? envsToImages[e.target.value][activeImage]
                        : '',
                      to: compareImages.to,
                    })
                    setSelectValue1(e.target.value)
                  }}
                  value={selectValue1}
                >
                  {[initialSelectState, ...Object.keys(envsToImages)].map((key) => (
                    <option key={key} value={key}>
                      {key}
                    </option>
                  ))}
                </select>

                <span style={{ margin: '0 1rem' }}>
                  <FormattedMessage defaultMessage="med" id="tools.screenshots.actions.toggle-between" />
                </span>

                <select
                  onBlur={() => {}}
                  onChange={(e) => {
                    setSelectValue2(e.target.value)
                    setCompareImages({
                      from: compareImages.from,
                      to: Object.keys(envsToImages).includes(e.target.value)
                        ? envsToImages[e.target.value][activeImage]
                        : '',
                    })
                  }}
                  value={selectValue2}
                >
                  {[initialSelectState, ...Object.keys(envsToImages)].map((key) => (
                    <option key={key} value={key}>
                      {key}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          {!compareImages.from || !compareImages.to ? (
            <img alt="Screenshot" src={renderImages()[activeImage]} style={{ maxWidth: '1200px' }} />
          ) : (
            <ReactCompareImage
              aspectRatio="taller"
              leftImage={compareImages.from}
              leftImageCss={{ objectFit: 'contain', objectPosition: 'top' }}
              leftImageLabel={selectValue1}
              rightImage={compareImages.to}
              rightImageCss={{ objectFit: 'contain', objectPosition: 'top' }}
              rightImageLabel={selectValue2}
            />
          )}
        </Popup>
      )}

      <h2 style={{ marginTop: '1rem' }}>
        <FormattedMessage
          defaultMessage="{amount} Skärmbilder"
          id="tools.screenshots.header.heading"
          values={{ amount: renderImages().length }}
        />
      </h2>
      <p>
        <FormattedMessage
          defaultMessage="Klicka på en bild för att se hela bilden"
          id="tools.screenshots.header.description"
        />
      </p>
      <hr />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gridGap: '2rem',
          justifyContent: 'center',
          marginBottom: '5rem',
          marginTop: '3rem',
        }}
      >
        {renderImages() && renderImages().length ? (
          renderImages().map((image, i) => (
            <div
              key={image}
              onClick={() => {
                setActiveImg(i)
                togglePopup(true)

                if (envsToImages[selectValue1] && envsToImages[selectValue2]) {
                  setCompareImages({
                    from: envsToImages[selectValue1][i],
                    to: envsToImages[selectValue2][i],
                  })
                }
              }}
              style={{
                cursor: 'pointer',
                background: '#ddd',
                backgroundImage: `url(${image})`,
                height: '250px',
                backgroundPosition: 'top',
                backgroundSize: 'cover',
                borderRadius: '3px',
                boxShadow: '0px 1px 0px 1px rgba(0, 0, 0, 0.1)',
              }}
            />
          ))
        ) : (
          <div style={{ textAlign: 'center', marginTop: '5rem' }}>
            <h2>
              <FormattedMessage
                defaultMessage="Hittade tyvärr inga skärmbilder"
                id="tools.screenshots.placeholder.heading"
              />
            </h2>
            <p>
              <FormattedMessage
                defaultMessage="Var vänlig kör följande kommando:"
                id="tools.screenshots.placeholder.lede"
              />
            </p>
            <code>{'yarn screenshot'}</code>
          </div>
        )}
      </div>
    </div>
  )
}
